import { useContext } from "react";
import { MyAccountContext } from "../context/MyAccountContext";

export const useMyAccount = () => {
  const {
    userData,
    companyData,
    contactTerra,
    collaborators,
    orderHistory,
    paymentDelivery,
    orderTargetCompanies,
    orderDetail,
    loadOrderDetail,
    setOrderDetailId,
    refreshMyAccount,
    isRefreshingMyAccount,
  } = useContext(MyAccountContext);

  return {
    userData,
    companyData,
    contactTerra,
    collaborators,
    orderHistory,
    paymentDelivery,
    orderTargetCompanies,
    loadOrderDetail,
    orderDetail,
    setOrderDetailId,
    refreshMyAccount,
    isRefreshingMyAccount,
  };
};

export default useMyAccount;
